export const COMPANY = {
  name: "DEM BAT",
  phone: "076 602 77 53",
  phoneRaw: "+41766027753",
  email: "info@dembat.ch",
  address: "Avenue Communes-Réunies 76, 1212 Grand-Lancy",
  city: "Genève",
  yearsExperience: "20+",
  founded: "2026",
};

export const WHATSAPP_NUMBER = COMPANY.phoneRaw.replace(/[^0-9]/g, "");
export const WHATSAPP_MESSAGE =
  "Bonjour, je souhaite un devis pour des travaux de rénovation à Genève.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

// All photos served locally from /public/photos/ (real DEM BAT photos)
export const IMAGES = {
  hero: "/photos/hero.jpg",
  about: "/photos/about.jpg",
  service_platrerie: "/photos/service-platrerie.jpg",
  service_peinture: "/photos/service-peinture.jpg",
  service_isolation: "/photos/service-isolation.jpg",
  service_stucs: "/photos/service-stucs.jpg",
  service_moulures: "/photos/service-moulures.jpg",
  service_facade: "/photos/service-facade.jpg",
  extra_stucs: "/photos/extra-stucs.jpg",
  extra_house: "/photos/extra-house.jpg",
};

export const SERVICES = [
  {
    id: "platrerie",
    title: "Plâtrerie",
    h3: "Plâtrerie et Cloisons à Genève",
    description: "Plâtrerie à Genève : murs et plafonds parfaitement lisses. La base d'un intérieur qui paraît neuf, jamais rafistolé.",
    image: IMAGES.service_platrerie,
  },
  {
    id: "peinture",
    title: "Peinture",
    h3: "Peinture Intérieure et Extérieure Genève",
    description: "Peinture intérieure à Genève. Un intérieur repensé, des couleurs justes, des finitions qui restent belles 10 ans plus tard.",
    image: IMAGES.service_peinture,
  },
  {
    id: "isolation",
    title: "Isolation",
    h3: "Isolation Thermique et Acoustique Genève",
    description: "Isolation thermique et acoustique à Genève. Plus de courants d'air, moins de bruit, jusqu'à 30% de chauffage économisé chaque hiver.",
    image: IMAGES.service_isolation,
  },
  {
    id: "stucs",
    title: "Stucs & Enduits décoratifs",
    h3: "Stucs et Enduits Décoratifs Genève",
    description: "Stucs décoratifs à Genève. Un mur qui devient une pièce maîtresse. L'effet d'un palais, sans le prix d'un palais.",
    image: IMAGES.service_stucs,
  },
  {
    id: "moulures",
    title: "Moulures & Décoration",
    h3: "Moulures et Décoration Genève",
    description: "Moulures en plâtre à Genève. Corniches, rosaces, plinthes : les détails qui font qu'on remarque immédiatement votre intérieur.",
    image: IMAGES.service_moulures,
  },
  {
    id: "facade",
    title: "Façade",
    h3: "Ravalement de Façade Genève",
    description: "Ravalement de façade à Genève. Votre immeuble retrouve sa prestance et vous gagnez de la valeur à la revente.",
    image: IMAGES.service_facade,
  },
];

// Single featured before / after project — real DEM BAT job site
export const PROJECTS = [
  {
    id: "p1",
    location: "Genève",
    year: "2024",
    before: "/photos/before-1.jpg",
    after: "/photos/after-1.jpg",
  },
];

export const WORK_TYPES = [
  { value: "platrerie", label: "Plâtrerie" },
  { value: "peinture", label: "Peinture" },
  { value: "isolation", label: "Isolation" },
  { value: "stucs", label: "Stucs & Enduits décoratifs" },
  { value: "moulures", label: "Moulures & Décoration" },
  { value: "facade", label: "Façade" },
  { value: "autre", label: "Autre" },
];
